import React from "react";
import SideBar from '../SideBar/SideBar';
import { Outlet } from 'react-router-dom';
import "./DashboardLayout.css";

const DashboardLayout = ({ onLogout }) => {
    return (
        <div className="bg-[#f3f4f6] min-h-screen flex flex-col">
            <SideBar onLogout={onLogout} />
            <main className="sm:ml-72 flex-1 flex flex-col min-h-screen">
                <div className="inner-content p-4 flex-1">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default DashboardLayout;